import { render, staticRenderFns } from "./Threshold.vue?vue&type=template&id=c9839ac8&"
import script from "./Threshold.vue?vue&type=script&lang=ts&"
export * from "./Threshold.vue?vue&type=script&lang=ts&"
import style0 from "./Threshold.vue?vue&type=style&index=0&id=c9839ac8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports